import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import api from "../../../../../../api/api";
import BackButton from "../../../../../../components/BackButton/BackButton";
import imgs from "../../../../../../assets/images/imgs";
import "./StudentProfileNew.css";
import CourseCard from "../../../../../../components/EnrolledCoursesCourseCard";
import csv_img from "../../../../../../assets/images/csv-file.png";
import file_img_storage from "../../../../../../assets/images/file-storage.png";
import png_svg from "../../../../../../assets/images/png-svg.svg";
import jpg_svg from "../../../../../../assets/images/jpg-svg.svg";
import doc_svg from "../../../../../../assets/images/doc-svg.svg";
import pdf_svg from "../../../../../../assets/images/pdf-svg.svg";
import txt_svg from "../../../../../../assets/images/txt-svg.svg";
import xls_svg from "../../../../../../assets/images/xls-svg.svg";
import svg_svg from "../../../../../../assets/images/svg-svg.svg";
import { useSelector, useDispatch } from "react-redux";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData } from "../../../../../../state/reducers/chatDrawerReducers";
import FilePreviewModal from "../../../../../../components/UploadDocument/FilePreviewModal";
import Pagination from "@mui/material/Pagination";
import Grid from "@mui/material/Grid";

function formatDate(dateString) {
  try {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "-";
  }
}

const COURSES_PAGE_SIZE = 12;

const StudentProfileNew = () => {
  const { token } = useAuth();
  const { student_id } = useParams();
  const [student, setStudent] = useState({});
  const [activeTab, setActiveTab] = useState("details");
const [enrolledCourses, setEnrolledCourses] = useState([]);
const [coursesPage, setCoursesPage] = useState(1);
const [coursesCount, setCoursesCount] = useState(0);
const location = useLocation();
  const teacherIdFromState = location.state?.teacher_id ?? null;
const roleFromState = location.state?.role ?? null;
const navigate = useNavigate();
  const dispatch = useDispatch();
const globalState = useSelector((state) => state?.globalState);
const role = globalState?.role
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
const departmentRole = globalState?.teacher_details?.data?.teacher_department_roles;
const [previewOpen, setPreviewOpen] = useState(false);
const [previewIndex, setPreviewIndex] = useState(0);
const handleBack = () => {
  if (location.state?.from) {
    navigate(location.state.from, {
      state: {
        openViewStudents: location.state?.openViewStudents,
        advisor: location.state?.advisor,
        ls: location.state?.ls
      }
    });
  } else {
    navigate(-1);
  }
};
  useEffect(() => {
    api
      .get(`/students/teacher/get-student/?student_id=${student_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) setStudent(res?.data?.data ?? {});
      })
      .catch(() => {});
  }, [student_id, token]);

  const interests = student?.interests ? Object.values(student.interests) : [];
  const languages = student?.language  ? Object.values(student.language)  : [];
  const subjects = student?.subject ? Object.values(student.subject) : [];

/* const CourseData = {
  teacher_id: student?.teacher_id || "12345",
  course: student?.course || "English",
  courseimage: student?.course_image || imgs.png.course_default,
  coursename: student?.course_name || "Course Name",
  enrolled_students: student?.enrolled_students || 0,
  lesson_count: student?.lesson_count || 0,
  start_date: student?.course_start_date || "—",
  end_date: student?.course_end_date || "—",
  description: student?.course_description || "No description available",
  course_info_image: student?.course_info_image || imgs.png.course_info_default,
  Teacher_name: student?.teacher_name || "Teacher Name",
  Teacher_title: student?.teacher_title || "Instructor",
  Sales_Courses_title: student?.sales_courses_title || "Featured Course",
  checkbox: student?.checkbox || false,
  location: student?.location || "—",
  location_name: student?.location_name || "Location",
}; */

// Reset to page 1 whenever the courses tab is (re)opened
useEffect(() => {
  if (activeTab === "courses") setCoursesPage(1);
}, [activeTab]);

useEffect(() => {
  if (activeTab !== "courses") return;
  api
    .get( `/students/teacher/get-student/?student_id=${student_id}&type=enrolled_courses&page=${coursesPage}`, {
      headers: {  
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
    .then((res) => {
      if (res.status === 200) {
        setEnrolledCourses(res?.data?.data?.data || []);
        setCoursesCount(res?.data?.data?.count ?? 0);
      }
    })
    .catch(() => {});
}, [activeTab, student_id, token, coursesPage]);

const coursesTotalPages = Math.max(1, Math.ceil(coursesCount / COURSES_PAGE_SIZE));

const handlePageChangeCourses = (event, page) => {
  setCoursesPage(page);
};

const PngIcon       = () => <img src={png_svg}          alt="PNG" style={{ width: 20, height: 20 }} />;
const JpgIcon       = () => <img src={jpg_svg}          alt="JPG" style={{ width: 20, height: 20 }} />;
const FileDocIcon   = () => <img src={doc_svg}          alt="DOC" style={{ width: 20, height: 20 }} />;
const FileXlsIcon   = () => <img src={xls_svg}          alt="XLS" style={{ width: 20, height: 20 }} />;
const FileCsvIcon   = () => <img src={csv_img}          alt="CSV" style={{ width: 20, height: 20 }} />;
const FilePdfIcon   = () => <img src={pdf_svg}          alt="PDF" style={{ width: 20, height: 20 }} />;
const TxtIcon       = () => <img src={txt_svg}          alt="TXT" style={{ width: 20, height: 20 }} />;
const FileSvgIcon   = () => <img src={svg_svg}          alt="SVG" style={{ width: 20, height: 20 }} />;
const FileStorageIcon = () => <img src={file_img_storage} alt="File" style={{ width: 20, height: 20 }} />;

const getFileTypeFromName = (filename) => {
  if (!filename || typeof filename !== "string") return "";
  const ext = filename.split(".").pop().toLowerCase();
  const typeMap = {
    png: "image/png", jpg: "image/jpeg", jpeg: "image/jpeg",
    gif: "image/gif", svg: "image/svg+xml", pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    txt: "text/plain", xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    csv: "text/csv",
  };
  return typeMap[ext] || "";
};

const getFileIcon = (fileName) => {
  const type = getFileTypeFromName(fileName);
  if (!type) return <FileStorageIcon />;
  if (type.includes("png"))                               return <PngIcon />;
  if (type === "text/plain")                              return <TxtIcon />;
  if (type.includes("jpg") || type.includes("jpeg"))     return <JpgIcon />;
  if (type.includes("pdf"))                              return <FilePdfIcon />;
  if (type.includes("xls") || type.includes("spreadsheet")) return <FileXlsIcon />;
  if (type.includes("csv"))                              return <FileCsvIcon />;
  if (type.includes("svg"))                              return <FileSvgIcon />;
  if (type.includes("word") || type.includes("document")) return <FileDocIcon />;
  return <FileStorageIcon />;
};

const isSpecialAbility = student?.is_special_ability === true;
const specialAbilityText = student?.special_ability || "";
// Fix the flatten — API returns deeply nested [[[[{}]]]]
const attachments = student?.files ? student.files.flat(Infinity) : [];
  return (
    <div className="sp-page">
      <BackButton onClick={handleBack} buttonName="Back" />

      {/* Tabs */}
      <div className="sp-tabs">
        <button
          className={`sp-tab ${activeTab === "details" ? "active" : ""}`}
          onClick={() => setActiveTab("details")}
        >
          Student Details
        </button>
      { !(departmentRole === "teacher") && 
        <button
          className={`sp-tab ${activeTab === "courses" ? "active" : ""}`}
          onClick={() => setActiveTab("courses")}
        >
          Courses Enrolled
        </button>
      }
      </div>

      {activeTab === "details" && (
        <div className="sp-card">

          {/* Top — avatar + about */}
          <div className="sp-top">
            <div className="sp-avatar-col">
              <img
                src={student?.student_profile_pic || imgs.png.student_chatbot_image}
                alt={student?.name}
                className="sp-avatar"
              />
              {/* ── Special ability indicator ── */}
              {student?.is_special_ability && (
                <div className="sp-ability-dot" />
              )}
              <p className="sp-avatar-name">{student?.name || "—"}</p>
            </div>

            <div className="sp-about">
              <h4 className="sp-about-title">About Student</h4>
              <p className="sp-about-text">
                {student?.introduction || "No introduction provided."}
              </p>
            </div>
          </div>
          <div className="sp-divider" />

          {/* Info grid */}
          <div className="sp-info-grid">
            <div className="sp-info-item">
              <span className="sp-info-label">Name</span>
              <span className="sp-info-value">{student?.name || "—"}</span>
            </div>
            <div className="sp-info-item">
              <span className="sp-info-label">Email</span>
              <span className="sp-info-value">{student?.email || "—"}</span>
            </div>
            <div className="sp-info-item">
              <span className="sp-info-label">Date of Birth</span>
              <span className="sp-info-value">{formatDate(student?.dob)}</span>
            </div>
            <div className="sp-info-item">
              <span className="sp-info-label">Gender</span>
              <span className="sp-info-value">{student?.gender || "—"}</span>
            </div>
            <div className="sp-info-item">
              <span className="sp-info-label">Grade</span>
              <span className="sp-info-value">{student?.grade ? `${student.grade}` : "—"}</span>
            </div>
            <div className="sp-info-item">
              <span className="sp-info-label">Location</span>
              <span className="sp-info-value">{student?.location || "—"}</span>
            </div>
          </div>

          <div className="sp-divider" />

          {/* Interests */}
          <div className="sp-section">
            <span className="sp-section-label">Interests</span>
            <div className="sp-tags">
              {interests.length > 0 ? (
                interests.map((interest, i) => (
                  <span key={i} className="sp-tag">{interest}</span>
                ))
              ) : (
                <span className="sp-empty">No interests selected</span>
              )}
            </div>
          </div>

                    {/* Language — only show if exists */}
          {subjects.length > 0 && (
            <>
              <div className="sp-divider" />
              <div className="sp-section">
                <span className="sp-section-label">Subjects</span>
                <div className="sp-tags">
                  {subjects.map((subject, i) => (
                    <span key={i} className="sp-tag">{subject}</span>
                  ))}
                </div>
              </div>
            </>
          )}

          {/* Language — only show if exists */}
          {languages.length > 0 && (
            <>
              <div className="sp-divider" />
              <div className="sp-section">
                <span className="sp-section-label">Language</span>
                <div className="sp-tags">
                  {languages.map((lang, i) => (
                    <span key={i} className="sp-tag">{lang}</span>
                  ))}
                </div>
              </div>
            </>
          )}
            {isSpecialAbility && (
              <>
                <div className="sp-divider" />
                <div className="sp-section">
                  <span className="sp-section-label">Diverse Learning Requirement (If Any)</span>
                  <p
                    className="sp-about-text"
                    style={{
                      overflowWrap: "anywhere",
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                      margin: 0,
                    }}
                  >
                    {specialAbilityText || "—"}
                  </p>
                </div>
              </>
            )}
            <div>
 
{attachments.length > 0 && (
  <>
    <div className="sp-divider" />
    <div className="sp-section">
      <span className="sp-section-label">Attachments</span>
      <div className="sp-attachments">

{attachments.map((file, i) => (
  <div
    key={i}
    className="ssp-file-item"
    style={{ cursor: "pointer" }}
    onClick={() => {
      setPreviewIndex(i);
      setPreviewOpen(true);
    }}
  >
    <div className="sp-attachment-icon-wrap">
      {getFileIcon(file.name)}
    </div>
    <span className="sp-attachment-name">{file.name}</span>
  </div>
))}
      </div>
    </div>
  </>
)}
            </div>
    
        </div>
      )}

  {activeTab === "courses" && (
        enrolledCourses.length > 0 ? (
          <>
            <div className="sp-courses-list">
              {enrolledCourses.map((course) => (
                <CourseCard
                  key={course.course_id}
                  courseId={course.course_id}
                  courseImage={course.course_image}
                  instructorImage={course.teacher_img_url}
                  instructorName={course.teacher_name}
                  category={course.subject}
                  title={course.name}
                  teacherId={teacherIdFromState}
                  role={roleFromState}
                  course={course}
                />
              ))}
            </div>

            {coursesCount > COURSES_PAGE_SIZE && (
              <Grid xs={12} container justifyContent={"center"} sx={{ marginTop: 2 }}>
                <Pagination
                  count={coursesTotalPages}
                  page={coursesPage}
                  onChange={handlePageChangeCourses}
                  color="primary"
                  hideNextButton={coursesPage === coursesTotalPages}
                  hidePrevButton={coursesPage === 1}
                />
              </Grid>
            )}
          </>
        ) : (
          <div className="sp-card sp-courses-empty">
            <p>No courses enrolled yet.</p>
          </div>
        )
      )}

      {role !== "Admin" && 
        <FloatingAIButton
          onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />}
      <FilePreviewModal
        isOpen={previewOpen}
        files={attachments}
        initialIndex={previewIndex}
        onClose={() => setPreviewOpen(false)}
        getFileIcon={(type, name) => getFileIcon(name)}
      />
    </div>
  );
};

export default StudentProfileNew;